function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Nearest-flight",
  transform: "translate(-694 -936)"
}, /*#__PURE__*/React.createElement("g", {
  id: "services",
  transform: "translate(216 924)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(478 12)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle",
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.795 6.21c.348 0 .656.213.782.53l.035.109 1.104 4.414h2.71c.323 0 .613.183.754.466l.046.11 1.684 5.053a.841.841 0 01-1.551.645l-.047-.113-1.492-4.477H5.374a.842.842 0 01-.804-.59l-1.274-5.1a.843.843 0 01.707-1.04l.11-.006h1.682zM.638 3.71a.842.842 0 01.99.511l.032.102 2.207 8.829a.842.842 0 00.702.63l.115.007h3.725a.842.842 0 01.106 1.678l-.106.007H8.2L7.567 18h-4.21l.655-2.625a2.52 2.52 0 01-1.728-1.637l-.05-.177-2.209-8.83a.843.843 0 01.613-1.022zM15 16.4l-2-1.8 2-1.8v.98h3v-.98l2 1.8-2 1.8v-1.02h-3v1.02zM4.743 2a1.685 1.685 0 11-.002 3.37A1.685 1.685 0 014.743 2z",
  id: "Shape",
  fill: "#95A0B3"
})))))));